export default "__VITE_ASSET__Crsm44As__"